import { createReducer } from '@reduxjs/toolkit';
import { ShareContext, SharingShape } from './model';
import * as sharingActions from './actions';
import * as routerActions from '../router/actions';
import { Page } from '../router/model';
import { applyTotal, EMPTY_TOTAL, Loading } from '../finder/model';

const initial: SharingShape = {
  sharingId: undefined,
  data: { assets: [], total: EMPTY_TOTAL, sharing_link: null },
  loading: Loading.none,
  hasNextPage: false,
  scrollHash: '',
  shareInProgress: {
    [ShareContext.pack]: false,
    [ShareContext.asset]: {},
    [ShareContext.allAssets]: false,
    [ShareContext.sharing]: {},
  },
  isReplacingPack: false,
};

export const sharingReducer = createReducer<SharingShape>(initial, (builder) =>
  builder
    .addCase(sharingActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(sharingActions.assetsChanged, (s, a) => {
      s.data.assets = a.payload.data.assets;
      s.data.sharing_link = a.payload.data.sharing_link ?? s.data.sharing_link;
      applyTotal(s.data.total, a.payload.data.total);

      s.hasNextPage = a.payload.hasNextPage;
      s.scrollHash = a.payload.scrollHash;
    })
    .addCase(sharingActions.thumbnailUpdated, (s, a) => {
      s.data.assets = s.data.assets.map((asset) =>
        asset.id === a.payload.assetId ? { ...asset, thumbnail_url: a.payload.url } : asset,
      );
    })
    .addCase(sharingActions.setShareInProgress, (s, a) => {
      if (a.payload.context === ShareContext.pack) {
        s.shareInProgress[a.payload.context] = a.payload.inProgress;
      } else if (a.payload.context === ShareContext.asset) {
        const { context } = a.payload;
        a.payload.assetIds.forEach((assetId) => {
          s.shareInProgress[context][assetId] = a.payload.inProgress;
        });
      } else if (a.payload.context === ShareContext.allAssets) {
        s.shareInProgress[a.payload.context] = a.payload.inProgress;
      } else if (a.payload.context === ShareContext.sharing) {
        s.shareInProgress[a.payload.context][a.payload.sharingId] = a.payload.inProgress;
      }
    })
    .addCase(routerActions.pagePathChanged, (s, a) => {
      if (a.payload.page === Page.sharing) {
        s.sharingId = a.payload.match.params.sharingId;
        s.data = { assets: [], total: EMPTY_TOTAL, sharing_link: null };
      }
    })
    .addCase(sharingActions.setIsReplacingPack, (s, a) => {
      s.isReplacingPack = a.payload.isReplacingPack;
    }),
);
